// imports
import { APP_DATA, ENV_DEV, ENV_BETA } from "./constants";

// constants
const API_BASE_URL_DEV = "https://dev-backend.shoptype.com";
const API_BASE_URL_BETA = "https://beta-backend.shoptype.com";
const API_BASE_URL_PROD = "https://backend.shoptype.com";

const apiBaseUrl = () => {
    if (window[APP_DATA].env) {
        if (window[APP_DATA].env === ENV_DEV) {
            return API_BASE_URL_DEV;
        } else if (window[APP_DATA].env === ENV_BETA) {
            return API_BASE_URL_BETA;
        } else {
            return API_BASE_URL_PROD;
        }
    } else {
        return API_BASE_URL_PROD;
    }
};

// get
export const get = async (url, headersObj = null) => {
    const requestOptions = {
        method: "GET",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
    };

    if (headersObj) {
        requestOptions.headers = { ...requestOptions.headers, ...headersObj };
    }

    const response = await fetch(apiBaseUrl() + url, requestOptions);
    return { ok: response.ok, data: await response.json() };
};

// post
export const post = async (url, reqBody, reqHeaders = null) => {
    let headers = { Accept: "application/json", "Content-Type": "application/json" };

    if (reqHeaders) {
        headers = { ...headers, ...reqHeaders }
    }

    const requestOptions = {
        method: "POST",
        headers,
        body: JSON.stringify(reqBody),
    };

    const response = await fetch(apiBaseUrl() + url, requestOptions);
    return { ok: response.ok, data: await response.json() };
};
